declare var CONFIGURATIONS;
const trustUrls = [new URL(CONFIGURATIONS.api_rest), new URL(CONFIGURATIONS.services_url), new URL(CONFIGURATIONS.ckan_url), new URL(CONFIGURATIONS.print_url)];
export default class Utils {

  static sortArrayByProperty(array, property, asc, property2) {
    let res = array.sort((a, b) => {
      const aValue = (a[property] !== null && a[property] !== undefined) ? a[property] : a[property2];
      const bValue = (b[property] !== null && b[property] !== undefined) ? b[property] : b[property2];
      return this.compareStrings(aValue, bValue, property2 !== undefined);
    });

    if (!asc) {
      res = res.reverse();
    }

    return res;
  }

  static sortArrayByPropertyInsideObject(array, object, property, asc) {
    const _this = this;
    let listElements = array;
    if (array && array.list) {
      listElements = array.list;
    }

    let res = listElements.sort((a, b) => {
      let compA = a[object] !== undefined ? a[object][property] : '-';
      let compB = b[object] !== undefined ? b[object][property] : '-';
      return _this.compareStrings(compA, compB) !== 0 ?
        _this.compareStrings(compA, compB) : _this.compareStrings(a[property], b[property]);
    });

    if (!asc) {
      res = res.reverse();
    }

    return res;
  }

  static arrayRemoveObjectWithProperty(array, property, value) {
    let res = [];
    if (array !== undefined) {
      res = array.filter(item => item[property] !== value);
    }

    return res;
  }

  static arrayContainsObjectWithProperty(array, property, value) {
    let res = false;
    if (array !== undefined) {
      res = array.filter(item => item[property] === value).length > 0;
    }

    return res;
  }

  static arrayReturnObjectWithProperty(array, property, value) {
    let listElements = array;
    if (array && array.hasOwnProperty('list')) {
      listElements = array.list;
    }

    return listElements.filter(item => item[property] === value)[0];
  }

  static simplifyArrayByProperty(array, property) {
    let res = [];
    if (array !== undefined) {
      for (let elem of array) {
        res.push(elem[property]);
      }
    }

    return res;
  }

  static simplifyArrayByPropertyInObject(array, object, property) {
    let res = [];
    let listElements = [];
    if (array && array.list) {
      listElements = array.list;
    } else if (array && array.length) {
      listElements = array;
    }

    for (let elem of listElements) {
      res.push(elem[object][property]);
    }

    return res;
  }

  static isEmpty(string) {
    let res = string === undefined || string === '';
    if (!res) {
      string = '' + string;
      res = res || string.trim().length === 0;
    }

    return res;
  }

  static compareStrings(a, b, checkNumbers) {
    if (!checkNumbers && (isNaN(a) || isNaN(b))) {
      a = this.normalize(a);
      b = this.normalize(b);
    }

    if (checkNumbers && !isNaN(parseInt(a, 10)) && !isNaN(parseInt(b, 10))) {
      a = parseInt(a, 10);
      b = parseInt(b, 10);
    }

    return (a < b) ? -1 : (a > b) ? 1 : 0;
  }

  static stringContainsString(a, b) {
    if (isNaN(a) || isNaN(b)) {
      a = this.normalize(a);
      b = this.normalize(b);
    }

    return a.indexOf(b) > -1;
  }

  static normalize(a) {
    return (a + '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  static arrayContainsString(array, text) {
    const contains = array.filter((elem) => {
      return this.stringContainsString(elem, text);
    });

    return contains.length > 0;
  }

  static isMobile() {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }

  static getFile(uri) {
    if (uri.startsWith("/")){
      
      return fetch(uri).then((response) => {
        return response.json();
      });

    }else{
  
      const url = new URL(uri);
      let trust = trustUrls.some(trustUrl => {
        return url.host === trustUrl.host;
      });
      if (trust) {
        const request = new Request(uri, {
          mode: 'no-cors'
        });
        return fetch(request).then((response) => {
          return response.json();
        });
      }

    }
  }

  static checkFileExtension(file, extension) {
    return file.name.indexOf(extension) !== -1;
  }

  static copyObject(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  static capitalizeSentence(str) {
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }

    return splitStr.join(' ');
  }

  static formatPrintDate() {
    const date = new Date();
    return `${new Date().getFullYear()}-${this.normalizeDateNumber(date.getMonth() + 1)}-${this.normalizeDateNumber(date.getDate())}_${this.normalizeDateNumber(date.getHours())}${this.normalizeDateNumber(date.getMinutes())}${this.normalizeDateNumber(date.getSeconds())}`;
  }

  static normalizeDateNumber(number) {
    return number < 10 ? `0${number}` : `${number}`;
  }


  static _sanitizeUrl(url) {
    const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;

    /** A pattern that matches safe data URLs. It only matches image, video, and audio types. */
    // eslint-disable-next-line
    const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;

    url = String(url);
    if (url === "null" || url.length === 0 || url === "about:blank") return "about:blank";
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN)) return url;
    console.error('Url invalidada en sanitacion: ', url);
    return `unsafe:${url}`;
  }


}
